import { Box, TextField } from "@mui/material";
import { Form, Formik } from "formik";
import * as yup from "yup";
import PrimaryButton from "../../../../components/buttons/PrimaryButton";

export default function SnowflakeConnectForm({ onSubmit, guideMode }) {
  const formInitialValues = {
    account_url: "",
    username: "",
  };
  const formCheckoutSchema = yup.object().shape({
    account_url: yup.string().required("required"),
    username: yup.string(),
  });
  const handleFormSubmit = (values) => {
    onSubmit(values);
  };

  return (
    <Box>
      <Formik
        onSubmit={handleFormSubmit}
        initialValues={formInitialValues}
        validationSchema={formCheckoutSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Box display="grid" mb="20px" gap="10px">
              <TextField
                fullWidth
                variant="filled"
                name="account_url"
                label="Account URL"
                value={values.account_url}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.account_url && !!errors.account_url}
                helperText={touched.account_url && errors.account_url}
                disabled={guideMode}
              />
              <TextField
                fullWidth
                variant="filled"
                name="username"
                label="Username (Default - “BreezeUser“. Leave empty if not changed in SQL)"
                value={values.username}
                onBlur={handleBlur}
                onChange={handleChange}
                error={!!touched.username && !!errors.username}
                helperText={touched.username && errors.username}
                disabled={guideMode}
              />
            </Box>
            <Box display="flex" justifyContent="center">
              <PrimaryButton type="submit" disabled={guideMode}>
                Connect
              </PrimaryButton>
            </Box>
          </Form>
        )}
      </Formik>
    </Box>
  );
}
